import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import featureStateSelector from './featureStateSelector'
import { TasksQueueState } from '../types'

export const pageSizeSelector = createSelector<ReduxState, TasksQueueState, number>(
  featureStateSelector,
  state => state.pagination.size
)
